/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Org_Activating_BodyInputs */



/**
* | output |
* | --- |
* | "Your contract has begun and your organization is being switched on. This usually takes less than an hour." |
*
* @param {Org_Activating_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const org_activating_body = /** @type {((inputs?: Org_Activating_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_Activating_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ihr Vertrag hat begonnen und Ihre Organisation wird gerade freigeschaltet. Das dauert in der Regel weniger als eine Stunde.")
	return /** @type {LocalizedString} */ ("Your contract has begun and your organization is being switched on. This usually takes less than an hour.")
});